import {createActionObject} from '../../../../../redux/utils'
import * as ActionTypes from './actionTypes'
import {createAction} from 'redux-actions'
import {getPanelSelectedYear} from './selectors'
import {loadedDataSet, loadWorkScheduleData, removeCorporateDaysByYear} from '../../../actions'
import * as api from '../../../apiCalls'
import {convertEffectiveDateInWorkSchedule} from '../../../utils'

export const setPanelShown = createAction(ActionTypes.HOLIDAYS_LIST_PANEL_SHOWN_SET)

export const openPanel = () => (dispatch, getState) => {
    dispatch(setPanelShown())
    dispatch(loadPanelData(getPanelSelectedYear(getState())))
}

export const closePanel = createAction(ActionTypes.CLOSE_PANEL)

export const loadData = createAction(ActionTypes.LOAD_DATA)
export const loadDataSuccess = createAction(ActionTypes.LOAD_DATA_SUCCESS)
export const loadDataFailure = createAction(ActionTypes.LOAD_DATA_FAILURE)
export const setPanelSelectedYear = createAction(ActionTypes.SELECTED_YEAR_SET)

export const openRemoveAllConfirmation = createAction(ActionTypes.REMOVE_ALL_CONFIRMATION_SHOW)

export const closeRemoveAllConfirmation = createAction(ActionTypes.REMOVE_ALL_CONFIRMATION_CLOSE)

export const setListTransformed = createAction(ActionTypes.LIST_TRANSFORMED_SET)

export const addImportedHolidays = createAction(ActionTypes.IMPORTED_HOLIDAYS_ADD)
export const removeImportedHolidays = createAction(ActionTypes.IMPORTED_HOLIDAYS_REMOVE)

export const changeSort = (sorting) => (dispatch) => {
    dispatch(createActionObject(ActionTypes.CHANGE_SORT, sorting))
    dispatch(setListTransformed(true))
}

export const loadPanelData = (year) => dispatch => {
    dispatch(loadData())
    dispatch(loadWorkScheduleData(
        year,
        () => {
            dispatch(loadDataSuccess(year))
            dispatch(setPanelSelectedYear(year))
            dispatch(setListTransformed(true))
        },
        () => dispatch(loadDataFailure()),
    ))
}

export const removeAllHolidays = () => (dispatch, getState) => {
    dispatch(loadData())

    const panelSelectedYear = getPanelSelectedYear(getState())
    api.deleteHolidays(panelSelectedYear)
       .then((data) => {
           dispatch(loadDataSuccess())
           dispatch(removeCorporateDaysByYear(panelSelectedYear))
           dispatch(loadedDataSet({
               corporateDays: {[panelSelectedYear]: data.corporateDays},
               defaultWorkSchedules: convertEffectiveDateInWorkSchedule(data.defaultWorkSchedules)
           }))
           dispatch(closeRemoveAllConfirmation())

       })
       .catch(() => {
           dispatch(loadDataFailure())
           dispatch(closeRemoveAllConfirmation())
       })
}



// WEBPACK FOOTER //
// ./web/js/administration/workSchedule/components/panels/holidayList/actions.js